module.exports = __webpack_public_path__ + "img/Gruppenführer_SB.297a84d5.svg";